<template>
  <a-table
    bordered
    :columns="columns"
    :components="components"
    :data-source="data"
    :rowKey="record => record.id"
    :expandedRowKeys="expandedRowKeys">
  </a-table>
</template>

<script>
import SearchForm from '@/views/assetLedger/modules/searchForm'
import { getAssetExport, getAssetTableData, getAssetTableTotal, getDeptTreeList } from '@/api/assetLedger'
import DataTabs from '@/views/assetLedger/modules/detailModules/dataTabs.vue'
import drawerExport from '@/views/assetLedger/modules/drawerExportSecond'
import { getTableScroll } from '@/views/assetLedger/modules/height'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import VueDraggableResizable from 'vue-draggable-resizable'
Vue.component('vue-draggable-resizable', VueDraggableResizable)
export default {
  name: 'TableData',
  components: {
    drawerExport,
    DataTabs,
    SearchForm
  },
  computed: {
    ...mapGetters(['assetCompanyId', 'assetAnlkl']),
    columns: {
      get () {
        let { sortedInfo } = this
        sortedInfo = sortedInfo || {}
        this.columnsData.forEach(item => {
          if (item.sortOrNot) {
            item.sorter = (a, b) => {}
            item.sortOrder = sortedInfo.columnKey === item.dataIndex && sortedInfo.order
          }
          item.align = 'center'
        })
        return this.columnsData
      },
      set (newValue) {
        this.columnsData = newValue
      }
    }
  },
  data () {
    this.components = {
      header: {
        cell: (h, props, children) => {
          console.log(props)
          const draggingMap = {}
          this.columns.forEach((col) => {
            draggingMap[col.key] = col.width
          })
          const draggingState = Vue.observable(draggingMap)
          let thDom = null
          const { key, ...restProps } = props
          const col = this.columns.find((col) => {
            console.log(col.dataIndex)
            const k = col.dataIndex || col.key
            return k === key
          })
          if (!col.width) {
            return <th {...restProps}>{children}</th>
          }
          const onDrag = (x) => {
            draggingState[key] = 0
            col.width = Math.max(x, 1)
          }
          const onDragstop = () => {
            draggingState[key] = thDom.getBoundingClientRect().width
          }
          return (
            <th
              {...restProps}
              v-ant-ref={(r) => (thDom = r)}
              width={col.width}
              class="resize-table-th"
            >
              {children}
              <vue-draggable-resizable
                key={col.key}
                class="table-draggable-handle"
                w={10}
                x={draggingState[key] || col.width}
                z={1}
                axis="x"
                draggable={true}
                resizable={false}
                onDragging={onDrag}
                onDragstop={onDragstop}
              ></vue-draggable-resizable>
            </th>
          )
        }
      }
    }
    return {
      data: [],
      columnsData: [],
      searchValue: '',
      // 表格数据
      tableData: {
        statistics: {
          mengeSum: 0,
          kanswSum: 0,
          qmjzSum: 0
        },
        loading: false
      },
      sortedInfo: null,
      scrollY: 0,
      toLeftWidth: 0,
      advanced: false,
      // 搜索条件
      searchModel: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sort: {},
      // 展开的行
      expandedRowKeys: [],
      // 选中的行
      selectedRows: [],
      rowSelection: {
        columnWidth: 40,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      // 左侧树的搜索条件
      treeSearchModel: {},
      visible: false,
      top: 0,
      left: 0,
      selectedRowsData: {}
    }
  },
  created () {
    this.columns = [
      {
        title: '',
        dataIndex: 'icon',
        scopedSlots: {
          customRender: 'icon'
        },
        align: 'center',
        width: 40
      },
      {
        title: '序号',
        dataIndex: 'xh',
        customRender: (text, record, index) => {
          return index + 1
        },
        align: 'center',
        width: 40
      },
      {
        title: '资产描述',
        dataIndex: 'x1',
        scopedSlots: {
          customRender: 'x1'
        },
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'x1' && sortedInfo.order,
        align: 'center',
        width: 170
      },
      {
        title: '所属公司',
        dataIndex: 'butxt',
        scopedSlots: {
          customRender: 'butxt'
        },
        align: 'center',
        width: 120
      },
      {
        title: '资产编号',
        dataIndex: 'assetNumber',
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'assetNumber' && sortedInfo.order,
        align: 'center',
        width: 120
      },
      {
        title: '处置状态',
        dataIndex: 'gdlgrpTxt1',
        align: 'center',
        width: 90
      },
      {
        title: '归口部门',
        dataIndex: 'ordtx',
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'ordtx' && sortedInfo.order,
        align: 'center',
        width: 120
      },
      {
        title: '使用部门',
        dataIndex: 'departmentname',
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'departmentname' && sortedInfo.order,
        align: 'center',
        width: 120
      },
      {
        title: '责任人',
        dataIndex: 'raumn',
        scopedSlots: {
          customRender: 'raumn'
        },
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'raumn' && sortedInfo.order,
        align: 'center',
        width: 90
      },
      {
        title: '购置价值/万元',
        dataIndex: 'kansw',
        scopedSlots: {
          customRender: 'kansw'
        },
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'kansw' && sortedInfo.order,
        align: 'center',
        width: 115
      },
      {
        title: '现值/万元',
        dataIndex: 'qmjz',
        scopedSlots: {
          customRender: 'qmjz'
        },
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'qmjz' && sortedInfo.order,
        align: 'center',
        width: 115
      },
      {
        title: '资产分类',
        dataIndex: 'txk20',
        scopedSlots: {
          customRender: 'txk20'
        },
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'txk20' && sortedInfo.order,
        align: 'center',
        width: 160
      },
      {
        title: '资产使用年限',
        dataIndex: 'ndjar',
        // sorter: (a, b) => {},
        sortOrNot: true,
        // sortOrder: sortedInfo.columnKey === 'ndjar' && sortedInfo.order,
        align: 'center',
        width: 115
      }
    ]
    // 获取表格数据
    // this.getDeptData()
    // 获取资产统计
    this.getAssetTotal()
  },
  mounted () {

  },
  watch: {
    assetCompanyId (newValue) {
      if (newValue.id !== '') {
        if (newValue.id === '空') {
          delete this.treeSearchModel.comid
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
        } else {
          this.treeSearchModel.comid = newValue.id
        }
      } else {
        delete this.treeSearchModel.comid
      }
      delete this.searchModel.comid
      if (newValue.id !== '空') {
        this.setSearchCondition(this.searchModel)
      }
    },
    assetAnlkl (newValue) {
      if (newValue.anlkl !== '' && newValue.anlkl !== '资产分类') {
        if (newValue.anlkl === '空') {
          delete this.treeSearchModel.anlkl
          delete this.treeSearchModel.typeCode
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
        } else {
          if (newValue.type === 'parent') {
            this.treeSearchModel.typeCode = newValue.anlkl
            delete this.treeSearchModel.anlkl
          } else {
            delete this.treeSearchModel.typeCode
            this.treeSearchModel.anlkl = newValue.anlkl
          }
        }
      } else {
        delete this.treeSearchModel.anlkl
        delete this.treeSearchModel.typeCode
      }
      delete this.searchModel.anlkl
      delete this.searchModel.typeCode
      if (newValue.anlkl !== '空') {
        this.setSearchCondition(this.searchModel)
      }
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    // 判断是否展开行
    showLine (expanded, record) {
      // this.$nextTick(() => {
      //   const firstTableHeader = document.querySelector('.ant-table-selection-column').offsetWidth
      //   const secondTableHeader = document.querySelector('.ant-table-align-center').offsetWidth
      //   this.toLeftWidth = firstTableHeader + secondTableHeader + 12
      // })
      // 只展开一行
      if (this.expandedRowKeys.length > 0) { // 进这个判断说明当前已经有展开的了
        // 返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        const index = this.expandedRowKeys.indexOf(expanded.id)
        if (index > -1) { // 如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1)
        } else {
          // 如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
          this.expandedRowKeys.push(expanded.id)
        }
      } else {
        // 数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(expanded.id)
      }
    },
    // 改变scrollY
    changeScrollY (extraHeight, type) {
      this.$nextTick(() => {
        this.scrollY = getTableScroll(extraHeight, 'assetTable', type)
        const dom = document.getElementById('assetTable')
        if (type === 'addAssetTableHeigth') {
          dom.classList.add('assetTableHeight_126')
        } else {
          dom.classList.remove('assetTableHeight_126')
        }
      })
    },
    // 保存展开状态字段
    saveAdvanced (advanced) {
      this.advanced = advanced
    },
    //  获取部门树用于第一次请求表格
    getDeptData () {
      const data = {
        paging: false,
        id: 0
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          console.log(res.data[0])
          this.treeSearchModel.comid = res.data[0].id
          this.setSearchCondition(this.searchModel)
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取表格数据
    getTableData (type) {
      this.tableData.loading = true
      this.searchModel = { ...this.searchModel, ...this.pagination, ...this.sort }
      this.expandedRowKeys = []
      getAssetTableData(this.searchModel).then(res => {
        if (res.status === 0) {
          if (res.data.list.length > 0) {
            for (let i = 0; i < res.data.list.length; i++) {
              const item = res.data.list[i]
              item.id = i
            }
          } else {
          }
          this.data = res.data.list
          this.tableData.loading = false
        } else {
          this.data = []
          this.tableData.loading = false
        }
      })
      // 获取资产统计
      this.getAssetTotal()
    },
    // 获取资产统计
    getAssetTotal () {
      getAssetTableTotal(this.searchModel).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.tableData.statistics = res.data
          } else {
            this.tableData.statistics = {
              mengeSum: 0,
              kanswSum: 0,
              qmjzSum: 0
            }
          }
        }
      })
    },
    // 搜索
    setSearchCondition (searchModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel }
      this.getTableData()
    },
    // 导出
    derive (searchModel) {
      const setSearchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel, ...this.sort }
      this.$refs.drawerExport.setTitle('导出')
      this.$refs.drawerExport.setModel(setSearchModel)
      this.$refs.drawerExport.setType(this.$sysInfo.MODAL_ADD)
      this.$refs.drawerExport.open(true)
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData()
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      if (sorter.field === 'ordtx') {
        this.sort.sortName = 'ord43'
      } else if (sorter.field === 'txk20') {
        this.sort.sortName = 'anlkl'
      } else if (sorter.field === 'x1') {
        this.sort.sortName = 'txt50'
      } else {
        this.sort.sortName = sorter.field
      }
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
        delete this.searchModel.sortName
        delete this.searchModel.sortType
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData('changePageNum')
    },
    // 关闭右键菜单
    closeMenu () {
      this.visible = false
    },
  }
}
</script>

<style lang="less">
//.resize-table-th {
//  position: relative;
//  .table-draggable-handle {
//    transform: none !important;
//    position: absolute;
//    height: 100% !important;
//    bottom: 0;
//    left: auto !important;
//    right: -5px;
//    cursor: col-resize;
//    touch-action: none;
//  }
//}
.rightTableDiv {
  height: 100%;
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
/deep/.ant-table-footer {
  padding: 0 !important;
  height: 40px;
  .footerDiv {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #E7F4FF;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    .footerDivOne ,.footerDivTwo ,.footerDivThree {
      width: 33.33%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      color: #333333;
      span:first-child {
        //margin-right: 20px;
      }
    }
    .footerDivOne {
      border-right: 1px solid #DDDDDD;
    }
    .footerDivTwo {
      border-right: 1px solid #DDDDDD;
    }
  }
}
/deep/.ant-table-expanded-row{
  >td{
    padding: 0;
    .expand_row{
      display: flex;
      .expand_left{
        width: 80px;
        //border-right: 1px solid #e8e8e8;
        // 线颜色修改
        border-right: 1px solid #bbbbbb;
        background-color: #eeeeee;
      }
      .expand_right{
        width: calc(100% - 80px);
        //padding: 0 10px 8px 10px;
      }
    }
  }
}
// /deep/.ant-table-pagination.ant-pagination {
//   margin: 10px 0 0 0 !important;
// }
/deep/.ant-table-wrapper.assetTable  {
  transition: height 300ms ease;
  height: calc(100% - 42px);
  >.ant-spin-nested-loading {
    height: 100%;
    >.ant-spin-container {
      height: calc(100% - 43px);
      .ant-table {
        height: 100%;
        .ant-table-content {
          height: 100%;
          .ant-table-scroll{
            height: 100%;
            .ant-table-body {
              transition: max-height 300ms ease;
              height: calc(100% - 80px);
            }
          }
        }
      }
      >.ant-table-pagination.ant-pagination {
        margin: 10px 0 0 0 !important;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    margin: 10px;
  }
  // /deep/.ant-table-bordered{
  //   .ant-table-thead > tr > th,
  //   .ant-table-tbody > tr > td{
  //     border-color: #DDDDDD;
  //   }
  //   .ant-table-header > table,
  //   .ant-table-body > table,
  //   .ant-table-fixed-left table,
  //   .ant-table-fixed-right table{
  //     border-color: #DDDDDD;
  //   }
  // }
}
.assetTableHeight_126 {
  height: calc(100% - 126px) !important;
}
.assetNameTable {
  .txt50Span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  //width: 100%;
  //display: flex;
  //flex-direction: row;
  //align-items: center;
  .expandBtn {
    //margin-right: 5px;
  }
}
.blueBtn {
  background: rgba(23, 145, 255, 0.1) !important;
  color: #1791FF;
  border: 1px solid rgba(23, 145, 255, 0.7) !important;
}
.orangeBtn {
  background: rgba(255, 142, 59, 0.1) !important;
  color: #FF8E3B;
  border: 1px solid rgba(255, 142, 59, 0.7) !important;
}
.greenBtn {
  background: rgba(54, 191, 125, 0.1) !important;
  color: #36BF7D;
  border: 1px solid rgba(54, 191, 125, 0.7) !important;
}
/deep/.ant-table-align-center {
  padding: 0 !important;
}
/deep/.ant-table-body-max-height-0 {
  //max-height: 0 !important;
}
/deep/.ant-table-tbody .activeHighLight{
  background-color: #e6f7ff !important;
}
/deep/.ant-table-tbody .evenNumberedDisplay{
  background-color: skyblue !important;
}
/deep/.ant-table-placeholder {
  position: absolute;
  background: none;
  border-top: none;
  border-bottom: none;
  border-radius: 0 0 4px 4px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 100px;
  .ant-empty-normal {
    margin: 0 !important;
  }
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: #eee;
}
.table-draggable-handle {
  /* width: 10px !important; */
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
.resize-table-th {
  position: relative;
}
</style>
